import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/phone/call-volume')({ staticData: { team: 'analytics' } });
